exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".restore-points-holder .grid {\n  width: 100%;\n  padding-top: 16px; }\n\n.restore-points-holder .table-action-text {\n  cursor: pointer;\n  display: inline-block;\n  height: 24px;\n  line-height: 1;\n  position: relative;\n  color: #007CBB; }\n  .restore-points-holder .table-action-text.disabled {\n    pointer-events: none;\n    opacity: 0.8; }\n  .restore-points-holder .table-action-text:hover {\n    text-decoration: underline; }\n\n.restore-points-holder .top-icon {\n  cursor: pointer;\n  margin-top: -4px;\n  margin-left: 10px; }\n  .restore-points-holder .top-icon.disabled {\n    fill: grey;\n    pointer-events: none; }\n\n.restore-points-holder .first-icon {\n  margin-left: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/restore-points/restore-points.scss
// module id = vexD
// module chunks = 0